import React from "react";
import { Link, useLocation } from "react-router-dom";

const ElementSidbar = (props) => {
  const { title,link, icon: IconComponent } = props;
  const location = useLocation();

  // Check if the current path matches the item's route
  const isActive = location.pathname === `/${link.replace(/\s+/g, "-")}`;

  return (
    <Link to={`/${link}`} style={{ textDecoration: "none", color: "inherit" }}>
      <li
        className={`${
          isActive ? "bg-primary text-darkTextColor" : ""
        }`}
      >
        <span
          className={`pr-0 py-[12px]  pl-[25px] flex ${
            isActive
              ? "hover:text-darkTextColor hovar:dark:text-textColor"
              : "hover:text-primary"
          }  duration-300  items-center`}
        >
          {IconComponent && <IconComponent className=" mr-[20px]" />}
          {title}
        </span>
      </li>
    </Link>
  );
};

export default ElementSidbar;
